declare global {
  var DEBUG: number;
}

window.DEBUG = 100;

const d = (lvl: number, ...args: any[]) => {
  if (window.DEBUG >= lvl) {
    console.debug(...args);
  }
};

export default d;
